export default __webpack_public_path__ + "27f8586fa182d11d0b558575be3459d1.svg";